import { publisherRelease } from "@ondit/publishing";
import {
	Button,
	ChipLink,
	ChipModal,
	ChipModalBody,
	ChipModalField,
	ChipModalHeader,
	ModalDescription,
} from "@ondit/ui";
import { useState } from "react";
import { useT } from "~/core/i18n";
import { usePublisherExtension } from "./extension";

export function InstallPublisher() {
	const [open, setOpen] = useState(false);
	const t = useT();
	return (
		<>
			<Button variant="ghost" onClick={() => setOpen(true)}>
				{t("publishing.install.title")}
			</Button>
			<ChipModal open={open} onOpenChange={setOpen} srTitle={t("publishing.install.title")}>
				<ChipModalHeader onClose={() => setOpen(false)} closeAriaLabel={t("common.close")}>
					{t("publishing.install.title")}
				</ChipModalHeader>
				<ChipModalBody>
					<ChipModalField type="custom" title="">
						<ModalDescription>{t("publishing.install.intro")}</ModalDescription>
					</ChipModalField>

					{(["chrome", "firefox"] as const).map((browser) => (
						<ChipModalField key={browser} type="custom" title={browser === "chrome" ? "Chrome" : "Firefox"}>
							<ChipLink href={`/generated/publisher/ondit-${browser}.zip`} download>
								{t(`publishing.install.${browser}`)}
							</ChipLink>
							<p className="hint">{t(`publishing.install.${browser}Help`)}</p>
						</ChipModalField>
					))}
					<ChipModalField type="custom" title="">
						<p>{t("publishing.install.use")}</p>
					</ChipModalField>
				</ChipModalBody>
			</ChipModal>
		</>
	);
}

export function PublisherConnection() {
	const extension = usePublisherExtension();
	const t = useT();
	if (extension.status === "connected") return null;
	return (
		<div className="publisher-connection" role="status">
			<div>
				<strong>{t(`publishFlow.extension.${extension.status}`)}</strong>
				{extension.status === "outdated" && (
					<p>{t("publishFlow.upgradeHelp", { version: publisherRelease.version })}</p>
				)}
			</div>
			<div className="platform-actions">
				<InstallPublisher />
				<Button variant="ghost" onClick={extension.check} disabled={extension.status === "checking"}>
					{t("publishFlow.recheck")}
				</Button>
			</div>
		</div>
	);
}
